enum Blockchain {
  Ethereum = "Ethereum",
  Solana = "Solana",
}

export default Blockchain;
